export default __webpack_public_path__ + "static/media/close_white.457fd632.svg";